export default __webpack_public_path__ + "static/media/4Pack_combinado_scroll.df47a145.png";